module.exports = __webpack_public_path__ + "img/雙魚座.d96db735.svg";